import styled from 'styled-components'

import { untilMd } from '@syconium/little-miss-figgy'

export const EmbroiderySectionWrapper = styled.section<{ hasBorder?: boolean }>`
  margin-top: ${o => o.theme.spacing(6)};
  border-top: ${o =>
    o.hasBorder ? `1px solid ${o.theme.color.deprecated.stoneLight}` : undefined};
  padding-top: ${o => (o.hasBorder ? o.theme.spacing(6) : undefined)};

  &.multi-colors-section {
    margin-top: ${o => o.theme.spacing(5)};
  }

  &.size-section {
    margin-top: ${o => o.theme.spacing(2)};
    .size-section-title {
      scroll-margin-top: 80px;
    }
  }

  &.embroidery-settings-section {
    padding-top: ${o => (o.hasBorder ? o.theme.spacing(5) : undefined)};
  }
  &.fit-section {
    margin-top: ${o => o.theme.spacing(4)};
  }

  &.personalize-section {
    margin-top: ${o => o.theme.spacing(4)};
  }

  ${untilMd} {
    padding: 0 ${o => o.theme.dimensions.layout.sidePadding.md}px;

    &.personalize-section {
      margin: 0 ${o => o.theme.dimensions.layout.sidePadding.md}px;
      margin-top: ${o => o.theme.spacing(4)};
      padding: 0 0;
      padding-top: ${o => (o.hasBorder ? o.theme.spacing(6) : undefined)};
    }

    &.embroidery-settings-section {
      margin: 0 ${o => o.theme.spacing(6)};
      margin-top: ${o => o.theme.spacing(6)};
      padding: 0 0;
      padding-top: ${o => (o.hasBorder ? o.theme.spacing(5) : undefined)};
    }
  }
`
